'use client';

import { Eye, EyeOff } from 'lucide-react';
import { useState, type ComponentProps, type JSX } from 'react';

import { cn } from '~/utils';
import { Show } from '~/components/show';
import { Input } from '~/components/input';
import { Button } from '~/components/button';

export function InputPassword({
  className,
  ...props
}: Omit<ComponentProps<typeof Input>, 'type'>): JSX.Element {
  const [shown, setShown] = useState(false);

  const toggle = () => {
    setShown((state) => !state);
  };

  return (
    <div className='relative'>
      <Input
        type={shown ? 'text' : 'password'}
        className={cn(
          'pr-10 [&::-ms-reveal]:hidden [&::-ms-clear]:hidden',
          className,
        )}
        {...props}
      />
      <Button
        type='button'
        tabIndex={-1}
        onClick={toggle}
        className='absolute top-[50%] translate-y-[-50%] right-0 bg-transparent hover:bg-transparent cursor-pointer py-0 px-10 shadow-none'
      >
        <Show when={shown}>
          <Eye />
        </Show>
        <Show when={!shown}>
          <EyeOff />
        </Show>
      </Button>
    </div>
  );
}
